module.exports = __webpack_public_path__ + "assets/9334c64ce30299f83e11a05f1f015c38.mp3";